import React from "react";

const PermissionsContext = React.createContext();

export default PermissionsContext;
